import React from 'react';
import Link from 'next/link';
import { RichText } from 'prismic-reactjs';
import { PrismicAwardProcess } from '../../types/prismic';
import styles from './grantProcess.module.scss';

type Props = PrismicAwardProcess;

const ProgramCurriculum = ({ data }: Props) => {
  const {
    award_process_active,
    cta_link_url,
    cta_link_text,
    program_title,
    program_description,
  } = data;

  return (
    <>
      <article
        className={`bg-pink-tan inner-width inner-width-padding inner-width-padding-double column center`}
      >
        <div className={`column ${styles.process}`}>
          <RichText render={program_title} />
          <RichText render={program_description} />
        </div>
        {award_process_active && cta_link_url && cta_link_text && (
          <Link href={cta_link_url[0].text}>
            <a className="button secondary no-arrow invert">
              {cta_link_text[0].text}
            </a>
          </Link>
        )}
      </article>
    </>
  );
};

export default ProgramCurriculum;
